import React, { useState } from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";

import periodos from "../../images/periodos.png";
import disponibilizarperiodos from "../../images/disponibilizacaoperiodo.png";
import mais from "../../images/mais.png";
import menu from "../../images/menu.png";
import close from "../../images/close.png";
import minhascotas from "../../images/MinhasCotas.png";
import maisCotas from "../../images/sinalMaisIcon.png";
import incluirCota from "../../images/incluirCota.png";
import incluirCotaManual from "../../images/incluirCotaManual.png";
import P2Imagem from "../../images/P2.png";
import checado from "../../images/checado.png";
import naoChecado from "../../images/naochecado.png";
import meusInteresses from "../../images/meusInteresses.png";
import detalhesInteresses from "../../images/detalhesInteresses.png";
import interesses from "../../images/interesses.png";
import incluirPeriodo from "../../images/incluirPeriodo.png";
import periodosutilizados from "../../images/periodosutilizados.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;

const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;

  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
 
  #text {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  #button {
    width: 100%;
   
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #voltar {
    diplay: grid;
    grid-template: 50% 50% / 100%;
    align-items: center;
    justify-content: center;
    button {
      border: none;
      
      background: transparent;
      &:hover {
        cursor: pointer;
      }
  }

`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  width: 80%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (min-width: 400px) {
    font-size: 1.5rem;
  }
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
`;

const H3 = styled.h3`
text-align: left;

color: ${Globais.CorAzulBackGround};
font-size: 1rem;

@media (min-width: 400px) {
  font-size: 1.2rem;
  a {
    color: #2d3436;
  }
  a:hover {
    color: #636e72;
  }
`;
const H3lista = styled.h3`
text-align: left;

color: ${Globais.CorAzulBackGround};
font-size: 1rem;

@media (min-width: 400px) {
  font-size: 1.2rem;
`;

const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 80%;

  @media (min-width: 300px) {
    width: 50%;
  }
  @media (min-width: 400px) {
    width: 40%;
  }
  @media (min-width: 500px) {
    width: 35%;
  }

  @media (min-width: 600px) {
    width: 25%;
  }

  @media (min-width: 900px) {
    width: 15%;
  }
  @media (min-width: 1100px) {
    width: 8%;
  }
`;
const ImagemMaior = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;

  @media (min-width: 900px) {
    width: 90%;
  }
`;
const ImagemMenor = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  justify-self: center;
  @media (min-width: 500px) {
    width: 90%;
  }

  @media (min-width: 600px) {
    width: 80%;
  }
  @media (min-width: 700px) {
    width: 70%;
  }
  @media (min-width: 900px) {
    width: 50%;
  }
  @media (min-width: 1100px) {
    width: 40%;
  }
  @media (min-width: 1300px) {
    width: 30%;
  }
`;
const ImagemFechar = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 15%;
  justify-self: center;
  @media (min-width: 400px) {
    width: 10%;
  }

  @media (min-width: 500px) {
    width: 8%;
  }
  @media (min-width: 600px) {
    width: 6%;
  }

  @media (min-width: 700px) {
    width: 6%;
  }
  @media (min-width: 900px) {
    width: 5%;
  }
`;
const Pergunta = styled.button`

   border: none;
  width: 80%;
 height: 10%;
  background: transparent;
  &:hover {
    cursor: pointer;
  `;

export default function ViewAjuda() {
  const [isP1Visible, setIsP1Visible] = useState(false);
  const [isP2Visible, setIsP2Visible] = useState(false);
  const [isP3Visible, setIsP3Visible] = useState(false);
  const [isP4Visible, setIsP4Visible] = useState(false);
  const [isP5Visible, setIsP5Visible] = useState(false);
  const [isP6Visible, setIsP6Visible] = useState(false);
  const [isP7Visible, setIsP7Visible] = useState(false);
  const [isP8Visible, setIsP8Visible] = useState(false);
  const [isP9Visible, setIsP9Visible] = useState(false);
  const [isP10Visible, setIsP10Visible] = useState(false);
  const [isP11Visible, setIsP11Visible] = useState(false);
  const [isP12Visible, setIsP12Visible] = useState(false);
  const [isP13Visible, setIsP13Visible] = useState(false);
  const [isP14Visible, setIsP14Visible] = useState(false);
  const [isP15Visible, setIsP15Visible] = useState(false);
  const [isP16Visible, setIsP16Visible] = useState(false);
  const [isP17Visible, setIsP17Visible] = useState(false);

  const P1 = () => {
    setIsP1Visible(!isP1Visible);
  };
  const P2 = () => {
    setIsP2Visible(!isP2Visible);
  };
  const P3 = () => {
    setIsP3Visible(!isP3Visible);
  };
  const P4 = () => {
    setIsP4Visible(!isP4Visible);
  };
  const P5 = () => {
    setIsP5Visible(!isP5Visible);
  };
  const P6 = () => {
    setIsP6Visible(!isP6Visible);
  };
  const P7 = () => {
    setIsP7Visible(!isP7Visible);
  };
  const P8 = () => {
    setIsP8Visible(!isP8Visible);
  };
  const P9 = () => {
    setIsP9Visible(!isP9Visible);
  };
  const P10 = () => {
    setIsP10Visible(!isP10Visible);
  };
  const P11 = () => {
    setIsP11Visible(!isP11Visible);
  };
  const P12 = () => {
    setIsP12Visible(!isP12Visible);
  };
  const P13 = () => {
    setIsP13Visible(!isP13Visible);
  };
  const P14 = () => {
    setIsP14Visible(!isP14Visible);
  };
  const P15 = () => {
    setIsP15Visible(!isP15Visible);
  };
  const P16 = () => {
    setIsP16Visible(!isP16Visible);
  };
  const P17 = () => {
    setIsP17Visible(!isP17Visible);
  };

  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>PERGUNTAS FREQUENTES</Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <H3>
            <p>
              {" "}
              Segue algumas perguntas frequentes. Clique na pergunta para ver a
              resposta.
            </p>

            <p>
              Caso ainda permaneça dúvidas, favor entrar em contato conosco
              clicando em "Fale Conosco" do Menu ou clicando nos ícones de
              Whatsapp que pode ser encontrado em todas as páginas.
            </p>
          </H3>
          <H3lista>
            <ol>
              <li>
                <Pergunta onClick={P1}>
                  <H3>Como cadastrar uma propriedade?</H3>
                </Pergunta>
                {isP1Visible ? (
                  <div>
                    <TextWrapper>
                      <H3>
                        <p>
                          Após se cadastrar, faça os seguintes procedimentos:
                        </p>
                        <p>
                          1º Abra o menu que fica no canto superior esquerdo:
                        </p>
                        <p>
                          {" "}
                          <Imagem src={menu}></Imagem>
                        </p>{" "}
                        <p> 2º Clique na opção "Minhas Cotas":</p>
                        <Imagem src={minhascotas}></Imagem>
                        <p>
                          {" "}
                          3º Clique no botão "mais" que fica no canto superior
                          direito:{" "}
                        </p>
                        <Imagem src={maisCotas}></Imagem>
                        <p>
                          {" "}
                          4º Selecione o empreendimento, o apartamento e o
                          número da cota:
                        </p>
                        <ImagemMaior src={incluirCota}></ImagemMaior>
                        <br />
                        <p> 5º Clique em incluir.</p>
                        <p>
                          Pronto! Propriedade cadastrada com sucesso!
                          Disponibilize seus períodos!
                        </p>
                        <br />
                        <p>
                          Obs:
                          <p>
                            {" "}
                            1 - Identifique o apartamento pelo nome e pela
                            capacidade.{" "}
                          </p>
                          <p>
                            2 - Caso não encontre o empreendimento ou o
                            apartamento clique no botão para incluir
                            manualmente.
                          </p>
                          <ImagemMenor src={P2Imagem}></ImagemMenor>
                        </p>
                        <div id="voltar">
                          <div id="text">
                            <p>Fechar</p>
                          </div>
                          <div id="button">
                            <button onClick={P1}>
                              <ImagemFechar src={close} />
                            </button>
                          </div>
                        </div>
                      </H3>
                    </TextWrapper>
                  </div>
                ) : null}
              </li>

              <li>
                <Pergunta onClick={P2}>
                  <H3>
                    Fui cadastrar minha propriedade mas não encontrei meu
                    resort/hotel, o que fazer?
                  </H3>
                </Pergunta>
                {isP2Visible ? (
                  <div>
                    <TextWrapper>
                      <H3>
                        <p>
                          Ao tentar cadastrar sua propriedade, caso não tenha
                          encontrado alguma informação, faça os seguintes
                          procedimentos:
                        </p>
                        <p>
                          1º Na tela onde faz o cadastro verifique a opção de
                          incluir propriedade manualmente no canto inferior
                          esquerdo:
                        </p>
                        <ImagemMaior src={incluirCota}></ImagemMaior>
                        <br />
                        <p> 2º Clique para incluir manualmente.</p>
                        <br />
                        <p> 3º Digite os dados e clique em incluir.</p>
                        <ImagemMaior src={incluirCotaManual}></ImagemMaior>
                        <br />
                        <br />
                        <p>
                          Pronto! Sua propriedade foi incluida com sucesso!
                          Disponibilize seus períodos.
                        </p>
                        <p>
                          Obs:
                          <p>
                            {" "}
                            Somente os dados marcados com * são obrigatórios, ou
                            seja, empreendimento, estado, cidade e capacidade.
                          </p>
                        </p>
                        <div id="voltar">
                          <div id="text">
                            <p>Fechar</p>
                          </div>
                          <div id="button">
                            <button onClick={P2}>
                              <ImagemFechar src={close} />
                            </button>
                          </div>
                        </div>
                      </H3>
                    </TextWrapper>
                  </div>
                ) : null}
              </li>

              <li>
                <Pergunta onClick={P3}>
                  <H3>Como disponibilizar um período?</H3>
                </Pergunta>
                {isP3Visible ? (
                  <div>
                    <TextWrapper>
                      <H3>
                        <p>
                          1º Abra o menu que fica no canto superior esquerdo:
                        </p>
                        <p>
                          {" "}
                          <Imagem src={menu}></Imagem>
                        </p>{" "}
                        <p> 2º Clique na opção "Minhas Cotas":</p>
                        <Imagem src={minhascotas}></Imagem>
                        <p>
                          {" "}
                          3º Identifique a propriedade cadastrada e clique em
                          períodos:{" "}
                        </p>
                        <Imagem src={periodos}></Imagem>
                        <p>
                          {" "}
                          4º identifique o período e sinalize como deseja
                          disponibilizar:
                        </p>
                        <ImagemMaior src={disponibilizarperiodos}></ImagemMaior>
                        <br />
                        <br />
                        <p>
                          Pronto! Período disponibilizado com sucesso! Basta
                          aguardar e será notificado assim que encontrarmos um
                          interesse compatível.
                        </p>
                        <p>Obs:</p>
                        <p>
                          Caso não tenha encontrado seu período, basta clicar no
                          botão + que fica no canto superior direito.
                        </p>
                        <ImagemMaior src={mais}></ImagemMaior>
                        <p>
                          1- Insira a data de início e fim e clique em incluir:
                        </p>
                        <ImagemMaior src={incluirPeriodo}></ImagemMaior>
                        <p>
                          2- Na relação de períodos, identifique o período
                          cadastrado e indique se deseja alugar ou troca:
                        </p>
                        <ImagemMaior src={disponibilizarperiodos}></ImagemMaior>
                        <p>
                          Pronto! Novo período disponibilizado com sucesso!
                          Basta aguardar e será notificado assim que
                          encontrarmos um interesse compatível.
                        </p>
                        <div id="voltar">
                          <div id="text">
                            <p>Fechar</p>
                          </div>
                          <div id="button">
                            <button onClick={P3}>
                              <ImagemFechar src={close} />
                            </button>
                          </div>
                        </div>
                      </H3>
                    </TextWrapper>
                  </div>
                ) : null}
              </li>

              <li>
                <Pergunta onClick={P4}>
                  <H3>Como cadastrar um interesse?</H3>
                </Pergunta>
              </li>
              {isP4Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>1º Abra o menu que fica no canto superior esquerdo:</p>
                      <p>
                        {" "}
                        <Imagem src={menu}></Imagem>
                      </p>{" "}
                      <p> 2º Clique na opção "Meus Interesses":</p>
                      <Imagem src={meusInteresses}></Imagem>
                      <p> 3º Clique no botão "+" no canto superior direito </p>
                      <Imagem src={maisCotas}></Imagem>
                      <p>
                        {" "}
                        4º identifique a localização, as características e o
                        período de interesse, depois clique em incluir:
                      </p>
                      <ImagemMaior src={detalhesInteresses}></ImagemMaior>
                      <br />
                      <p>
                        {" "}
                        5º O interesse incluído aparecerá na relação de
                        interesses. Indique se deseja alugar (pagar para se
                        hospedar) ou trocar.
                      </p>
                      <ImagemMaior src={interesses}></ImagemMaior>
                      <br />
                      <p>
                        Pronto! Interesse incluído com sucesso! Basta aguardar e
                        será notificado assim que encontrarmos um período
                        disponibilizado compatível.
                      </p>
                      <p> Obs: </p>
                      <p>
                        1 - Clicando em cotas você poderá cadastrar suas
                        propriedadess e disponibilizar seus períodos para troca,
                        caso não tenha feito ainda.
                      </p>
                      <p>
                        2 - Clicando em detalhes é possível visualizar ou
                        alterar as informações do seu interesse.
                      </p>
                      <p>
                        3 - Caso deseje alugar (pagar para se hospedar), indique
                        o valor máximo a pagar. Não se preocupe, se encontrarmos
                        uma oferta de menor valor, você pagará menos do que o
                        valor indicado. Esse valor máximo não será exibido para
                        os proprietários, somente a plataforma conhecerá. Ele
                        servirá apenas para que você não seja notificado sobre
                        ofertas de maior valor.
                      </p>
                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P4}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}

              <li>
                <Pergunta onClick={P5}>
                  <H3> O que é um interesse?</H3>
                </Pergunta>
              </li>
              {isP5Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Interesse está relacionado a estadia que deseja. Você
                        pode desejar ter sua estadia em determinado(s)
                        resort(s)/hotel(is), em determinado(s) período(s),
                        mediante aluguel, ou seja, você paga para ter essa
                        estadia, ou mediante troca, você disponibiliza um
                        período de sua propriedade para ter a estadia desejada.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P5}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}

              <li>
                <Pergunta onClick={P6}>
                  <H3> O que é um proprietário autenticado?</H3>
                </Pergunta>
              </li>
              {isP6Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Um proprietário autenticado é aquele que a equipe da
                        Multicotas já fez a checagem da veracidade de sua
                        propriedade em relação a uma cota de determinado
                        resort/hotel.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P6}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}

              <li>
                <Pergunta onClick={P7}>
                  <H3>Como saber se sou um proprietário autenticado?</H3>
                </Pergunta>
              </li>
              {isP7Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Para saber se você já é um proprietário autenticado,
                        basta seguir os seguintes passos:
                      </p>
                      <p>1º Abra o menu que fica no canto superior esquerdo:</p>
                      <p>
                        {" "}
                        <Imagem src={menu}></Imagem>
                      </p>{" "}
                      <p> 2º Clique na opção "Minhas Cotas":</p>
                      <Imagem src={minhascotas}></Imagem>
                      <p>
                        {" "}
                        3º Visualize na cota cadastrado o ícone que fica no lado
                        esquerdo.
                      </p>
                      <p>Poderá ser checado:</p>
                      <Imagem src={checado}></Imagem>
                      <p>Ou não checado:</p>
                      <Imagem src={naoChecado}></Imagem>
                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P7}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P8}>
                  <H3>Como faço para me tornar um proprietário autenticado?</H3>
                </Pergunta>
              </li>
              {isP8Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Assim que você cadastrar um cota, receberá no seu e-mail
                        as instruções necessárias para que se torne um
                        proprietário autenticado. Basta seguir essas instruções.
                      </p>
                      <p>Obs:</p>
                      <p>
                        Caso não tenha recebido o e-mail, entre em contato
                        conosco para que possamos reenviar um outro e-mail.
                      </p>{" "}
                      <p>
                        {" "}
                        Para entrar em contato conosco, basta clicar na opção{" "}
                        <a href="/contato" target="_blank">
                          Fale Conosco
                        </a>{" "}
                        do menu ou clicando nos ícones do nosso whatsapp que
                        está por toda a plataforma.
                      </p>
                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P8}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}

              <li>
                <Pergunta onClick={P9}>
                  <H3>
                    Quais as limitações de um proprietário não autenticado?
                  </H3>
                </Pergunta>
              </li>
              {isP9Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Um proprietário não autenticado poderá utilizar a
                        plataforma em todas as suas funcionalidades, cadastrar
                        cotas, disponibilizar períodos e incluir interesses.
                      </p>
                      <p>
                        No entanto, não terão suas transações (troca ou aluguel)
                        concluídas até que seja autenticado.
                      </p>
                      <p>
                        Ou seja, mesmo que a Multicotas encontre alguma
                        oportunidade, ela não será concretizada.
                      </p>
                      <p>
                        Por esse motivo, é extremamente importante que o
                        proprietário proceda com os trâmites da autenticação tão
                        logo possa.
                      </p>
                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P9}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P10}>
                  <H3>
                    Não sou proprietário mas gostaria de cadastrar um interesse
                    em alugar uma cota. É possível?
                  </H3>
                </Pergunta>
              </li>
              {isP10Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Sim, é possível. Só não poderá cadastrar os interesses
                        de trocas, pois esses ficam restritos aos proprietários.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P10}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}

              <li>
                <Pergunta onClick={P11}>
                  <H3>
                    Posso disponibilizar meu período para troca e aluguel ao
                    mesmo tempo?
                  </H3>
                </Pergunta>
              </li>
              {isP11Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Sim, é possível. Você será notificado tanto se houver
                        interesses de aluguel quanto de troca para o período
                        disponibilizado.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P11}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P12}>
                  <H3>
                    Posso cadastrar um interesse para troca e aluguel ao mesmo
                    tempo?
                  </H3>
                </Pergunta>
              </li>
              {isP12Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Sim, é possível. Você será notificado tanto se aparecer
                        proprietários querendo alugar quanto proprietários
                        querendo trocar o período cadastrado.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P12}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P13}>
                  <H3>
                    Meu período é de 7 dias, mas gostaria de disponibilizar
                    somente alguns desses dias. Como fazer?
                  </H3>
                </Pergunta>
              </li>
              {isP13Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>1º Abra o menu que fica no canto superior esquerdo:</p>
                      <p>
                        {" "}
                        <Imagem src={menu}></Imagem>
                      </p>{" "}
                      <p> 2º Clique na opção "Minhas Cotas":</p>
                      <Imagem src={minhascotas}></Imagem>
                      <p> 3º Na cota cadastrada clique em períodos: </p>
                      <Imagem src={periodos}></Imagem>
                      <p>
                        4º Clique no botão "+"" que fica no canto superior
                        direito:
                      </p>
                      <ImagemMaior src={mais}></ImagemMaior>
                      <p>
                        5º Insira a data de início e fim e clique em incluir:
                      </p>
                      <ImagemMaior src={incluirPeriodo}></ImagemMaior>
                      <p>
                        6º Na relação de períodos, identifique o período
                        cadastrado e indique se deseja alugar ou troca:
                      </p>
                      <ImagemMaior src={disponibilizarperiodos}></ImagemMaior>
                      <p>
                        Pronto! Novo período disponibilizado com sucesso! Basta
                        aguardar e será notificado assim que encontrarmos um
                        interesse compatível.
                      </p>
                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P13}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P14}>
                  <H3>
                    Se disponibilizar meus períodos, fico impedido de realizar
                    transações com outras pessoas?
                  </H3>
                </Pergunta>
              </li>
              {isP14Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Não. Quando encontrarmos as oportunidades de troca ou
                        aluguel, você será notificado e questionado se deseja
                        prosseguir com a transação. Podendo optar por não
                        prosseguir caso já tenha comprometido o período.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P14}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P15}>
                  <H3>
                    Posso cadastrar outra pessoa para receber as notificações de
                    minha cota?
                  </H3>
                </Pergunta>
              </li>
              {isP15Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Não. Por questões de segurança a plataforma só permite o
                        cadastro de um e-mail e um celular.
                      </p>

                      <div id="voltar">
                        <div id="text">
                          <p>Fechar</p>
                        </div>
                        <div id="button">
                          <button onClick={P15}>
                            <ImagemFechar src={close} />
                          </button>
                        </div>
                      </div>
                    </H3>
                  </TextWrapper>
                </div>
              ) : null}
              <li>
                <Pergunta onClick={P16}>
                  <H3>
                    Vou utilizar ou já negociei um dos meus períodos, como não
                    ser mais notificado sobre ele?
                  </H3>
                </Pergunta>
              </li>
              {isP16Visible ? (
                <div>
                  <TextWrapper>
                    <H3>
                      <p>
                        Para não ser mais notificado sobre um período que deseja
                        utilizar ou já negociou basta seguir os seguintes
                        passos:
                      </p>
                      <p>1º Abra o menu que fica no canto superior esquerdo:</p>
                      <p>
                        {" "}
                        <Imagem src={menu}></Imagem>
                      </p>{" "}
                      <p> 2º Clique na opção "Minhas Cotas":</p>
                      <Imagem src={minhascotas}></Imagem>
                      <p> 3º Na cota cadastrada clique em períodos: </p>
                      <Imagem src={periodos}></Imagem>
                      <p>
                        {" "}
                        4º identifique o período e sinalize que deseja utilizar
                        ou que a transação já foi concluída:
                      </p>
                      <ImagemMaior src={periodosutilizados}></ImagemMaior>
                      <br />
                      <p>
                        Pronto! Não será mais notificado sobre esse período.
                      </p>
                    </H3>
                  </TextWrapper>

                  <div id="voltar">
                    <div id="text">
                      <p>Fechar</p>
                    </div>
                    <div id="button">
                      <button onClick={P16}>
                        <ImagemFechar src={close} />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
            </ol>
          </H3lista>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
